"use client";

import type { ICmsHeroSplitQuote } from "@mw/shared/payload-types";

import { clsx } from "clsx";
import Star20 from "@ui/icons/20x20/star-20.svg";

const STAR_COUNT = 5;

export function HeroSplitQuote({ quote }: { quote: ICmsHeroSplitQuote }) {
  const { title, review, name } = quote;

  return (
    <div className='tw-flex tw-flex-col tw-gap-6'>
      <div className='tw-flex tw-items-center tw-gap-1 tw-scale-[0.8] tw-origin-left' role='img' aria-label='5 stars'>
        {Array.from({ length: STAR_COUNT }).map((_, i) => (
          <Star20 key={i} className={clsx("tw-shrink-0 tw-text-[#F5A623]")} aria-hidden='true' />
        ))}
      </div>

      <p className='tw-type-base tw-text-black'>&ldquo;{review}&rdquo;</p>

      <div className='tw-flex tw-flex-col tw-gap-2.5'>
        {name && <span className='tw-type-base tw-font-medium tw-text-black'>{name}</span>}
        {title && <span className='tw-type-xs tw-text-gray-500'>{title}</span>}
      </div>
    </div>
  );
}
